import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M7.5 10.9V13c0 .3.2.5.5.5s.5-.2.5-.5v-2.1c.5-.3.7-.9.4-1.4-.2-.5-.8-.7-1.3-.4s-.7.9-.4 1.4c.1.1.2.3.3.4M12 6h-1V3.5c0-1.7-1.3-3-3-3s-3 1.3-3 3V6H4c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1M6 3.5c0-1.1.9-2 2-2s2 .9 2 2V6H6zM12 15H4V7h8z" />
  </svg>
);
const SvgLock = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="lock" {...props} />;
export default SvgLock;
